module.exports = __webpack_public_path__ + "static/media/download-black.e04dd1b6.svg";